<template>
    <div class="ppt-wrap">
        <!--<div class="title">在当前光标处插入内容</div>
        <el-input
                type="textarea"
                rows="5"
                v-model="inputContent"
                placeholder="请输入需要插入的内容"
                class="input"
        ></el-input>
        <div class="class-error">{{error1}}</div>
        <el-button type="primary" size="mini" :disabled="true"
                   @click="actionSetContent" class=""
        >在当前光标处插入内容</el-button>-->

        <el-button type="primary" size="mini"
                   @click="actionGetContent" class="class-button"
        >获取选中的文字内容</el-button>
        <div class="class-display">{{displayText}}</div>
        <div class="class-error">{{error2}}</div>
        <el-button type="primary" size="mini"
                   @click="actionGetImg" class="class-button"
        >插入在线图片</el-button>
        <el-input
                type="textarea"
                rows="5"
                v-model="imgsUrl"
                placeholder="请输入需要插入的图片地址"
                class="input"
        ></el-input>
        <el-button type="primary" size="mini"
                   @click="actionGetShow" class="class-button"
        >插入幻灯片</el-button>
        <el-input
                type="textarea"
                rows="5"
                v-model="pptData"
                placeholder="请输入需要插入幻灯片信息"
                class="input"
        ></el-input>
        <div class="class-error">{{error3}}</div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "pptBar",
        props: ['docEditor', 'extractedText','config'],
        data: function () {
            return {
                displayText: '',
                inputContent: '',
                error1: '',
                error2: '',
                error3: '',
                imgsUrl:'',
                pptData:'',
            }
        },
        methods: {
            actionGetContent: function () {
                console.log(this.config,'ppt.config')
                var expression =
                {
                    object: 'text',//操作文本内容，必填项
                    type: 'selected'//操作类型是选择，必填项
                }
                this.docEditor.getDocumentContent(expression);
                setTimeout(() => {
                    log("this.extractedText", this.extractedText)
                    if (!this.extractedText['text']) {
                        this.error2 = '请先选中文字'
                    } else {
                        this.error2 = ''
                        this.displayText = this.extractedText['text']
                    }
                }, 200)
            },
            actionGetImg: function () {
                var expression =
                {
                    object:"slide",//表示是演示文档，必填项
                    type:"insertUrlImg",//表示是插入在线图片，必填项
                    imgUrl:this.imgsUrl//图片的url
                }
                this.docEditor.setDocumentContent(expression);
            },

            actionGetShow: function () {
                // var pptDatas = JSON.parse(this.pptData);
                // var pptContent = pptDatas.data[0];
                // var pptImg = pptDatas.img;
                // var expression =
                // {
                //     object:"slide",//表示是演示文档，必填项
                //     type:"insertPPTSlides",//表示是插入幻灯片，必填项
                //     content:pptContent,//提取出的自定义数据格式的数据
                //     img:pptImg,//提取出的缓存图片的base64对象
                // }
                // this.docEditor.setDocumentContent(expression);
                 setTimeout(() => {
                    log("this.extractedText", this.extractedText)
                    if (!this.pptData) {
                        this.error3 = '请先输入幻灯片信息'
                    } else {
                        this.error3 = ''
                        var pptDatas = JSON.parse(this.pptData);
                        var pptContent = pptDatas.data[0];
                        var pptImg = pptDatas.img;
                        var expression =
                            {
                                object:"slide",//表示是演示文档，必填项
                                type:"insertPPTSlides",//表示是插入幻灯片，必填项
                                content:pptContent,//提取出的自定义数据格式的数据
                                img:pptImg,//提取出的缓存图片的base64对象
                            }
                        }
                        this.docEditor.setDocumentContent(expression);

                    }, 200)
                },
        }
    }
</script>

<style scoped>
    .ppt-wrap {
        padding: 20px;
    }
    .title {
        font-size: 14px;
    }
    .input {
        margin-top: 8px;
    }
    .class-button {
        margin-top: 25px;
    }
    .class-display {
        width: 225px;
        height: 100px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        margin-top: 15px;
        line-height: 20px;
        overflow-y: auto;
        padding: 5px 15px;
    }
    .class-error {
        height: 20px;
        font-size: 12px;
        color: #F45858;
    }

    .el-textarea__inner:focus {
        border-color:#C6482A;
    }
    .el-input__inner:focus{
        border-color:#C6482A;
    }
    .el-button+.el-button {
        margin-left: 0;
    }
    .el-button--primary {
        background-color: #C6482A;
        border-color: #C6482A;
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        background-color: #C6482A;
        border-color: #C6482A;
    }

</style>



// WEBPACK FOOTER //
// src/components/pptBar.vue